import React from 'react';
import { Images, previewFile } from 'utils';
import { TextRow, EditWithIcon } from 'components';

export const PrevUploadedFile = ({ item }) => {
    return (
        <div>
            <div className="uploaded-signature-box">
                <img className="uploaded-signature-image" src={Images.signatureIcon} alt="icon" />
                <div className="full-width">
                    <div className="full-width">
                        <div className="space-between-align-start">
                            <p className="uploaded-signature-name" style={{ width: '100%' }}>
                                <TextRow
                                    name={
                                        item?.value?.name ? item?.value?.name : item?.value?.originalName ? item?.value?.originalName : '--'
                                    }
                                />
                            </p>
                            {(item?.value?.key || item?.value?.url) && (
                                <div className="flex-align-start" style={{ gap: 10, height: 20 }}>
                                    <button
                                        type='button'
                                        onClick={() => previewFile(item?.value)} className="reset-btn-by-default"
                                    >
                                        <img style={{ height: 20 }} src={Images.showEye} alt={'view'} />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
